import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import AdminCalls from "@/pages/AdminCalls";

const PhoneLeads = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="Phone Leads"
        description="Manage phone leads and call tracking"
      />
      
      <AdminCalls />
    </>
  );
};

export default PhoneLeads;
